import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'lib-segment-progress-bar',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './segment-progress-bar.component.html',
    styleUrl: './segment-progress-bar.component.css'
})
export class SegmentProgressBarComponent implements OnInit {
    @Input() currentProgress: number = 0;
    @Input() totalProgress: number = 0;
    @Input() verticalSpacing: boolean = false;

    counterArray: number[] = [];

    ngOnInit(): void {
        if (this.currentProgress) {
            this.counterArray = Array.from({ length: this.totalProgress }, (v, k) => k + 1);
        }
    }
}
